import React from "react";
import Button from "../button";
import Icon from "../icon";
import Dropdown from "./dropdown";
const ButtonGroup = Button.Group;
import classNames from "classnames";

export default class DropdownButton extends React.Component {
  static defaultProps = {
    align: {
      points: ["tr", "br"],
      overlay: {
        adjustX: 1,
        adjustY: 1
      },
      offset: [0, 4],
      targetOffset: [0, 0]
    },
    type: "default"
  };

  render() {
    const {
      type,
      overlay,
      trigger,
      align,
      children,
      className,
      onClick,
      ...restProps
    } = this.props;
    const cls = classNames({
      "ant-dropdown-button": true,
      [className]: !!className
    });
    return (
      <ButtonGroup
        {...restProps}
        className={cls}
        ecId={`${this.props.ecId}_ButtonGroup@e056er`}
      >
        <Button
          ecId={`${this.props.ecId}_Button@5yv16h`}
          type={type}
          onClick={onClick}
        >
          {children}
        </Button>
        <Dropdown
          ecId={`${this.props.ecId}_Dropdown@l7e303`}
          align={align}
          overlay={overlay}
          trigger={trigger}
        >
          <Button ecId={`${this.props.ecId}_Button@kth8bh`} type={type}>
            <Icon ecId={`${this.props.ecId}_Icon@j23eap`} type="down" />
          </Button>
        </Dropdown>
      </ButtonGroup>
    );
  }
}



// WEBPACK FOOTER //
// ./_antd1.11.2/dropdown/dropdown-button.jsx